// NATIVE

// INSTALLED
import { Alert, Box, Snackbar } from '@mui/material';

// CUSTOM

/**
 * SnackAlert component displays a snackbar with an alert message.
 *
 * @param {object} props - The properties object.
 * @param {boolean} props.open - Controls whether the snackbar is open.
 * @param {string} props.text - The text message to display in the alert.
 * @param {string} props.severity - The severity level of the alert (e.g., 'error', 'warning', 'info', 'success').
 * @param {function} props.onclick - The function to call when the snackbar is closed.
 * @param {boolean} [props.autohidden=true] - Determines if the snackbar should automatically hide after a duration.
 *
 * @returns {JSX.Element} The rendered SnackAlert component.
 */
export const SnackAlert = (props: any) => {
  //  PROPS
  const { open, text, severity, onclick, autohidden = true } = props;

  //  CONST FUNCTIONS
  const handleClose = () => {
    onclick(false);
  };

  return (
    <Box sx={{ width: 500, top: 2 }}>
      {autohidden ? (
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            variant="filled"
            sx={{ width: '100%', marginTop: 7 }}
          >
            {text}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          open={open}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            variant="filled"
            sx={{ width: '100%', marginTop: 7 }}
          >
            {text}
          </Alert>
        </Snackbar>
      )}
    </Box>
  );
};
